const common = {
  "site.name": "KakobuyFinds",
  "site.tagline": "Najlepsza baza produktów Kakobuy",
  "nav.home": "Strona główna",
  "nav.finds": "Znaleziska",
  "nav.blog": "Blog",
  "nav.contact": "Kontakt",
  "nav.cssbuy": "CSSBuy Spreadsheet",
  "nav.superbuy": "Superbuy Spreadsheet",
  "nav.safety": "Bezpieczeństwo",
  "nav.menu.categories": "Kategorie produktów",
  "nav.menu.articles": "Artykuły SEO",
  "nav.menu.external": "Linki zewnętrzne",
  "hero.badge": "Kakobuy Spreadsheet Polska 2026",
  "hero.title.line1": "Najlepsza Baza Produktów",
  "hero.title.line2": "Kakobuy Finds & Spreadsheet",
  "hero.subtitle.line1": "Odkrywaj najlepsze produkty Kakobuy dzięki aktualizowanej bazie Spreadsheet.",
  "hero.subtitle.line2": "Znajdź sneakersy, streetwear, elektronikę i popularne produkty w jednym miejscu.",
  "hero.cta.sheet": "Kakobuy Sheet",
  "hero.cta.buy": "Buy It Now",
  "hero.dropdown.placeholder": "Wybierz kategorię produktów...",
  "about.badge": "Co to jest Kakobuy Spreadsheet?",
  "about.title.line1": "Twoja baza",
  "about.title.line2": "produktów i",
  "about.title.line3": "spreadsheet finds",
  "about.paragraph1": "Kakobuy Spreadsheet to kompleksowa baza danych produktów stworzona dla entuzjastów zakupów online. Zawiera starannie wyselekcjonowane linki do produktów, oceny jakości, porównania cen oraz szczegółowe informacje o każdej kategorii. Dzięki regularnym aktualizacjom zawsze masz dostęp do najświeższych znalezisk.",
  "about.paragraph2": "Niezależnie czy szukasz sneakersów, streetwearu, elektroniki czy akcesoriów — nasz spreadsheet pomaga zaoszczędzić godziny przeszukiwania internetu. Wszystkie produkty są weryfikowane pod kątem jakości i autentyczności, a społeczność użytkowników regularnie dodaje nowe znaleziska.",
  "about.trust.item1": "Aktualizowana baza produktów",
  "about.trust.item2": "Setki sprawdzonych linków",
  "about.trust.item3": "Kategorie premium",
  "about.trust.item4": "Darmowy dostęp",
  "categories.title.small": "Przeglądaj kategorie",
  "categories.title.line1": "14 Kategorii",
  "categories.title.line2": "Produktów",
  "finds.title": "Popularne Finds",
  "finds.year": "2026",
  "finds.subtitle": "Najnowsze i najpopularniejsze znaleziska z naszej społeczności",
  "finds.badge": "Nowości",
  "comparison.label": "Bezpieczeństwo & Porównanie",
  "comparison.title.line1": "Kakobuy",
  "comparison.title.line2": "vs CSSBuy",
  "comparison.title.line3": "& Superbuy",
  "comparison.right.title.line1": "Zobacz pełne",
  "comparison.right.title.line2": "porównanie Spreadsheet",
  "comparison.right.text": "Dowiedz się, który spreadsheet najlepiej odpowiada Twoim potrzebom. Porównujemy Kakobuy, CSSBuy, Superbuy i Oopbuy pod kątem jakości bazy produktów, doświadczeń użytkowników oraz popularności. Sprawdź nasz szczegółowy artykuł i podejmij świadomą decyzję. W naszym przewodniku znajdziesz również wskazówki dotyczące bezpiecznych zakupów i unikania oszustw.",
  "comparison.cta": "Przeczytaj artykuł SEO",
  "faq.label": "FAQ",
  "faq.title": "Najczęściej zadawane pytania",
  "footer.brand": "KAKOBUYFINDS",
  "footer.description": "Najlepsza polska baza produktów Kakobuy. Znajdź sprawdzone linki, porównaj ceny i odkrywaj nowe produkty każdego dnia.",
  "footer.address": "Adres",
  "footer.phone": "Telefon",
  "footer.email": "Email",
  "footer.privacy": "Polityka prywatności",
  "footer.copyright": "© 2026 KakobuyFinds. Wszelkie prawa zastrzeżone.",
  "article.back": "← Wróć do Kakobuy Spreadsheet",
  "article.related": "Powiązane kategorie",
  "article.related_articles": "Powiązane artykuły",
  "category.shoes": "Buty",
  "category.hoodies": "Bluzy / Swetry",
  "category.tshirts": "T-Shirty",
  "category.jackets": "Kurtki",
  "category.pants": "Spodnie / Szorty",
  "category.headwear": "Nakrycia głowy",
  "category.sets": "Zestawy",
  "category.underwear": "Bielizna / Majtki",
  "category.jersey": "Koszulki sportowe",
  "category.accessories": "Akcesoria",
  "category.bags": "Torby",
  "category.belts": "Paski",
  "category.perfumes": "Perfumy",
  "category.other": "Inne rzeczy",
};

export default common;